import React, { useState } from "react";
import { AnimationList } from "./AnimationList";
import styles from "../styles/components/DropdownAnimation.module.css";

function Dropdown({ onSelect, animations }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Select Animation");

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (anim) => {
    onSelect(anim.fbx);
    setIsOpen(false);
  };

  return (
    <div className={styles.dropdown}>
      <button className={styles.dropButton} onClick={toggleDropdown}>
        Select Animation
      </button>
      {isOpen && (
        <div className={styles.dropdownContent}>
          {animations.map((anim, index) => (
            <a key={index} onClick={() => handleOptionClick(anim)}>
              {anim.name.replace(/_/g, " ")}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}

export default Dropdown;
